import bilAPI from "../api";

export const getClassrooms = ({
  uuid,
  exam_center,
  region,
  is_full,
  page,
  page_size,
}) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/core/classrooms/${uuid ? uuid + "/" : ""}`, {
          params: {
            exam_center: exam_center,
            region: region,
            is_full: is_full,
            page: page,
            page_size: page_size,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const postClassroom = (body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/core/classrooms/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const patchClassroom = (uuid, body) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .patch(`/core/classrooms/${uuid}/`, body)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const deleteClassroom = (uuid) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .delete(`/core/classrooms/${uuid}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const exportClassroomPassesPDF = (classroom) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/core/classroom_pdf/`, { classroom })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};

export const exportAllClassroomPassesPDF = (exam_center) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .post(`/core/exam_center_pdf/`, { exam_center })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    } catch (error) {
      reject(error);
    }
  });
};
